var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "400px" },
      model: {
        value: _vm.showDialog,
        callback: function ($$v) {
          _vm.showDialog = $$v
        },
        expression: "showDialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "text-h6" }, [
            _vm._v(_vm._s(_vm.dialogTitle)),
          ]),
          _c(
            "v-card-text",
            [
              !_vm.successMessage
                ? _c("div", [
                    _vm.isHtmlDescription
                      ? _c("p", {
                          staticClass: "text-body-1",
                          domProps: {
                            innerHTML: _vm._s(_vm.dialogDescription),
                          },
                        })
                      : _c("p", { staticClass: "text-body-1" }, [
                          _vm._v(_vm._s(_vm.dialogDescription)),
                        ]),
                  ])
                : _vm._e(),
              _c("v-text-field", {
                attrs: {
                  autofocus: "",
                  placeholder: _vm.mailingListResource.name,
                  disabled: _vm.disableInput,
                  filled: "",
                  color: "accent",
                },
                model: {
                  value: _vm.name,
                  callback: function ($$v) {
                    _vm.name = $$v
                  },
                  expression: "name",
                },
              }),
              _c("v-text-field", {
                ref: "emailInput",
                attrs: {
                  placeholder: _vm.mailingListResource.email,
                  disabled: _vm.disableInput,
                  type: "email",
                  filled: "",
                  "error-messages": _vm.emailErrorMessages,
                  color: "accent",
                },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.submitInfo.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.emailAddress,
                  callback: function ($$v) {
                    _vm.emailAddress = $$v
                  },
                  expression: "emailAddress",
                },
              }),
              !!_vm.successMessage
                ? _c("p", { staticClass: "text-body-1 success--text" }, [
                    _vm._v(_vm._s(_vm.successMessage)),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { color: "accent" }, on: { click: _vm.closeDialog } },
                [_vm._v(_vm._s(_vm.commonResource.close))]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "accent", disabled: _vm.disableInput },
                  on: { click: _vm.submitInfo },
                },
                [_vm._v(_vm._s(_vm.commonResource.submit))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }